import React from 'react';
import { GridReactContextProvider } from '../../../Utils/DataGridWrapper/GridContext';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import { useUserAdminOrgs } from '../../Hooks/UseUserAdminOrgs';
import { UserProgressReportTable } from './UserProgressReportTable/UserProgressReportTable';
import './UserProgressReports.scss';

/**
 * UserProgressReports Component
 *
 * Wrapper component for displaying user progress reports with organization filtering.
 * Provides the necessary context and organization data for the UserProgressReportTable.
 *
 * @returns {JSX.Element} Rendered user progress reports component
 */
export const UserProgressReports = () => {
    const { adminOrganizationOptions, adminOrganizations, isOrgsLoading } = useUserAdminOrgs({
        withAllOption: true,
        withCoursesAndSignDocs: true
    });

    return (
        <div className="UserProgressReports">
            <GridReactContextProvider>
                {adminOrganizationOptions && adminOrganizations && !isOrgsLoading ? (
                    <div className="reportDataGridContainer">
                        <UserProgressReportTable
                            organizationsOptions={adminOrganizationOptions}
                            adminOrganizations={adminOrganizations}
                        />
                    </div>
                ) : (
                    <LoadingSpinner />
                )}
            </GridReactContextProvider>
        </div>
    );
};

export default UserProgressReports; 